module.exports = __webpack_public_path__ + "static/media/mobile-image-2.66182a71.png";